<template>
  <v-container style="width:100vw;height:100vh;background: #373737;">
    <v-row
      align="center"
      justify="center"
      class="mx-auto"
      style="margin-top:100px;max-width:800px;"
    >
      <v-btn
        dark
        class="text-lowercase font-weight-light"
        router
        :to="'/admin'"
        tile
        text
      >
        Stats
      </v-btn>

      <v-btn
        dark
        router
        :to="'/db-admin'"
        class="text-lowercase font-weight-light"
        text
      >
        DB
      </v-btn>
      <v-btn
        dark
        router
        :to="'/admin_payouts'"
        class="text-lowercase font-weight-light"
        text
      >
        Payouts
      </v-btn>
      <v-btn
        dark
        router
        :to="'/admin_spons'"
        class="text-lowercase font-weight-light"
        text
      >
        Spons
      </v-btn>

      <v-col cols="12" align="center">
        <v-card dark>
          <v-card-title>
            <v-btn
              @click="create_xml"
              :disabled="selected_row.length === 0"
              color="teal"
              >Skapa XML</v-btn
            >
            <v-checkbox
              v-model="selected_only"
              label="Dölj omarkerade"
            ></v-checkbox>

            <v-spacer></v-spacer>
            <v-text-field
              dark
              v-model="search"
              append-icon="mdi-magnify"
              label="Sök"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :items="streamers"
            :headers="headers"
            :items-per-page="16"
            :search="search"
            v-model="selected_row"
            @click:row="view_more"
            show-select
            item-key="SID"
            v-on:toggle-select-all="select_all"
            dark
          >
            <template v-slot:item.USER_NAME="{ item }">
              <v-list-item style="display:flex;width:250px;" class="grow">
                <v-list-item-avatar
                  style="overflow:visible;"
                  color="grey darken-3"
                >
                  <v-icon
                    style="position:absolute;top:0;left:-30px;"
                    left
                    v-if="item.PAYMENT_TYPE === 'BANK2'"
                    >mdi-contactless-payment-circle</v-icon
                  >
                  <img
                    class="elevation-6"
                    alt=""
                    :src="`https://hihat.io/api/images/users/${item.SID}.png`"
                    @error="image_error"
                  />
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title style="text-align: left;">{{
                    item.USER_NAME
                  }}</v-list-item-title>
                </v-list-item-content>

                <v-spacer></v-spacer>
              </v-list-item>
            </template>
            <template v-slot:item.NOTES="{ item }">
              {{ item.NOTES ? item.NOTES.length : 0 }}
            </template>
            <template v-slot:item.SALARY="{ item }">
              <div>
                <v-chip
                  style="margin-left: -12px;"
                  color="teal"
                  dark
                  v-if="item.SID in payed_to"
                  >{{
                    item.DONATION_EARNED -
                      item.DONATION_FEES +
                      item.SHOP_EARNED -
                      item.SHOP_VAT -
                      item.SHOP_FEES -
                      item.DONATION_EMPLOYER_FEE -
                      item.TOTAL_TAX
                  }}
                  kr</v-chip
                >
                <span v-else
                  >{{
                    item.DONATION_EARNED -
                      item.DONATION_FEES +
                      item.SHOP_EARNED -
                      item.SHOP_VAT -
                      item.SHOP_FEES -
                      item.DONATION_EMPLOYER_FEE -
                      item.TOTAL_TAX
                  }}
                  kr</span
                >

                <div
                  @mouseenter="hover_sid = item.SID"
                  @mouseleave="hover_sid = null"
                  style="height: 49px; width: 100%; position: absolute; left: 10%; margin-top: -36px;z-index: 1;"
                >
                  <v-btn
                    color="teal"
                    @click.stop="payout(item)"
                    style="right:0;position:absolute;"
                    v-show="hover_sid === item.SID"
                    >Pay</v-btn
                  >
                </div>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="edit_row" max-width="690">
      <v-card class="mx-auto" max-width="600" v-if="row_in_edit !== null">
        <v-list-item three-line>
          <v-list-item-content>
            <div class="text-overline mb-4">
              {{ row_in_edit.USER_NAME }}
            </div>
            <v-list-item-title class="text-h5 mb-1">
              {{ row_in_edit.FIRST_NAME }} {{ row_in_edit.LAST_NAME }}
            </v-list-item-title>
            <v-list-item-subtitle>{{
              row_in_edit.PERSONAL_NUMBER
            }}</v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-avatar tile size="80" color="grey">
            <img
              class="elevation-6"
              alt=""
              :src="`https://hihat.io/api/images/users/${row_in_edit.SID}.png`"
              @error="image_error"
            />
          </v-list-item-avatar>
        </v-list-item>
        <v-card-text class="text-h5 font-weight-bold">
          <v-expansion-panels dark>
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{
                  row_in_edit.DONATION_EARNED -
                    row_in_edit.DONATION_FEES +
                    row_in_edit.SHOP_EARNED -
                    row_in_edit.SHOP_VAT -
                    row_in_edit.SHOP_FEES -
                    row_in_edit.DONATION_EMPLOYER_FEE -
                    row_in_edit.TOTAL_TAX
                }}
                kr
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card-text>
                  <v-row>
                    <v-col style="text-align: left;">
                      Donationer
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model.number="row_in_edit.DONATION_EARNED"
                        suffix="kr"
                        style="max-width:90px;height: 18px;margin-top: -2px;"
                        dense
                        type="number"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col> {{ row_in_edit.DONATION_EARNED }} kr </v-col>
                  </v-row>
                  <v-row>
                    <v-col style="text-align: left;">
                      Avgift
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model.number="row_in_edit.DONATION_FEES"
                        suffix="kr"
                        style="max-width:90px;height: 18px;margin-top: -2px;"
                        dense
                        type="number"
                      >
                      </v-text-field>
                    </v-col>

                    <v-col>
                      {{
                        row_in_edit.DONATION_EARNED - row_in_edit.DONATION_FEES
                      }}
                      kr
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col style="text-align: left;">
                      Shop
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model.number="row_in_edit.SHOP_EARNED"
                        suffix="kr"
                        style="max-width:90px;height: 18px;margin-top: -2px;"
                        dense
                        type="number"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col>
                      {{
                        row_in_edit.DONATION_EARNED -
                          row_in_edit.DONATION_FEES +
                          row_in_edit.SHOP_EARNED
                      }}
                      kr
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col style="text-align: left;">
                      Moms
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model.number="row_in_edit.SHOP_VAT"
                        suffix="kr"
                        style="max-width:90px;height: 18px;margin-top: -2px;"
                        dense
                        type="number"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col>
                      {{
                        row_in_edit.DONATION_EARNED -
                          row_in_edit.DONATION_FEES +
                          row_in_edit.SHOP_EARNED -
                          row_in_edit.SHOP_VAT
                      }}
                      kr
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col style="text-align: left;">
                      Shop-Avgift
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model.number="row_in_edit.SHOP_FEES"
                        suffix="kr"
                        style="max-width:90px;height: 18px;margin-top: -2px;"
                        dense
                        type="number"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col>
                      {{
                        row_in_edit.DONATION_EARNED -
                          row_in_edit.DONATION_FEES +
                          row_in_edit.SHOP_EARNED -
                          row_in_edit.SHOP_VAT -
                          row_in_edit.SHOP_FEES
                      }}
                      kr
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col style="text-align: left;">
                      Arb.Avgift
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model.number="row_in_edit.DONATION_EMPLOYER_FEE"
                        suffix="kr"
                        style="max-width:90px;height: 18px;margin-top: -2px;"
                        dense
                        type="number"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col>
                      {{
                        row_in_edit.DONATION_EARNED -
                          row_in_edit.DONATION_FEES +
                          row_in_edit.SHOP_EARNED -
                          row_in_edit.SHOP_VAT -
                          row_in_edit.SHOP_FEES -
                          row_in_edit.DONATION_EMPLOYER_FEE
                      }}
                      kr
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col style="text-align: left;">
                      Skatt
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model.number="row_in_edit.TOTAL_TAX"
                        suffix="kr"
                        style="max-width:90px;height: 18px;margin-top: -2px;"
                        dense
                        type="number"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col>
                      {{
                        row_in_edit.DONATION_EARNED -
                          row_in_edit.DONATION_FEES +
                          row_in_edit.SHOP_EARNED -
                          row_in_edit.SHOP_VAT -
                          row_in_edit.SHOP_FEES -
                          row_in_edit.DONATION_EMPLOYER_FEE -
                          row_in_edit.TOTAL_TAX
                      }}
                      kr
                    </v-col>
                  </v-row>
                  <v-divider dark></v-divider>
                  <v-row>
                    <v-col style="text-align: left;">
                      Totalt
                    </v-col>
                    <v-col> </v-col>
                    <v-col>
                      {{
                        row_in_edit.DONATION_EARNED -
                          row_in_edit.DONATION_FEES +
                          row_in_edit.SHOP_EARNED -
                          row_in_edit.SHOP_VAT -
                          row_in_edit.SHOP_FEES -
                          row_in_edit.DONATION_EMPLOYER_FEE -
                          row_in_edit.TOTAL_TAX
                      }}
                      kr
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
       
        <v-card-text class="text-h5 font-weight-bold">
          <v-expansion-panels @change="add_note=false">
            <v-expansion-panel>
              <v-expansion-panel-header>
                Meddelanden ({{ row_in_edit.NOTES ? row_in_edit.NOTES.length : 0 }})
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-btn  @click="add_note=true"><v-icon>mdi-plus</v-icon>Meddelande</v-btn>
                <v-card v-show="add_note" class="mx-auto" max-width="600">
            <v-card-text>
              <v-combobox
                   v-model="nn_title"
                   :items="suggestions.titles"
                   label="Titel"
                   outlined
                   dense
        ></v-combobox>
        <v-combobox
                   v-model="nn_message"
                   :items="suggestions.message"
                   label="Meddelande"
                   outlined
                   dense
        ></v-combobox>
        <v-combobox
                   v-model="nn_links_to"
                   :items="suggestions.links_to"
                   label="Länka till"
                   outlined
                   dense
        ></v-combobox>
        <v-combobox
                   v-model="nn_action"
                   :items="suggestions.action"
                   label="Knapp-text"
                   outlined
                   dense
        ></v-combobox>
            </v-card-text>
            <v-card-actions><v-btn @click="create_note" block color="green"><v-icon>mdi-plus</v-icon>Skapa</v-btn></v-card-actions>
            </v-card> 
                <v-list>
                  <v-list-item
                    v-for="(item) in row_in_edit.NOTES"
                    :key="item.NID"
                    ><v-card>
                      <v-card-text>
                        <v-list-item-content>
                          <v-list-item-title
                            >{{ item.TITLE }}
                            <v-btn icon
                              ><v-icon
                                @click="
                                  () => {
                                    delete_note(item.NID);
                                  }
                                "
                                >mdi-delete</v-icon
                              ></v-btn
                            ></v-list-item-title
                          >
                          <v-list-item-subtitle>{{
                            item.MESSAGE
                          }}</v-list-item-subtitle>
                          <v-list-item-subtitle
                            ><v-btn small>{{
                              item.ACTION
                            }}</v-btn></v-list-item-subtitle
                          >
                          <v-list-item-subtitle
                            >=> {{ item.LINKSTO }}</v-list-item-subtitle
                          >
                          <v-list-item-subtitle
                            ><i>{{ item.CREATED }}</i></v-list-item-subtitle
                          >
                        </v-list-item-content>
                      </v-card-text>
                    </v-card>
                  </v-list-item></v-list
                >
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            :disabled="selected_row.includes(row_in_edit)"
            @click="add_to_selected_row"
            color="black"
          >
            <v-icon>mdi-plus</v-icon>Registrera skatt
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="payout_dialog" max-width="600px" persistent>
      <v-card>
        <v-btn
          icon
          @click="payout_dialog = false"
          style="position:absolute;right:5px;top:5px;"
          ><v-icon>mdi-close</v-icon></v-btn
        >
        <v-card-title>
          <span class="text-h5">Skapa utbetalning</span>
        </v-card-title>
        <p
          v-if="payout_status.error_verbose !== ''"
          style="position:absolute;left:24px;top:40px;"
        >
          {{ payout_status.error_verbose }}
        </p>
        <v-card-text :style="{ opacity: payout_status.loading ? 0.4 : 1.0 }">
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-menu
                  v-model="show_start_date"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="payout_data.start_date"
                      label="Från"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="payout_data.start_date"
                    @input="show_start_date = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-menu
                  v-model="show_end_date"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="payout_data.end_date"
                      label="Till"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="payout_data.end_date"
                    @input="show_end_date = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <v-text-field
                  label="Telefonnummer"
                  v-model="payout_data.phone_number"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="6" sm="6" md="6">
                <v-text-field
                  label="Lön (netto)"
                  v-model="payout_data.salary"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn text v-if="payout_status.has_error">
            {{ payout_status.error_type }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            dark
            :loading="payout_status.loading"
            color="green"
            @click="create_payout"
            v-if="!payout_status.done"
          >
            Swisha
          </v-btn>
          <v-btn v-if="payout_status.done" dark color="green" text>
            Betalning utförd<v-icon>mdi-check</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "Admin-payout",
  components: {},

  data: function() {
    return {
      payed_to: {},
      payout_status: {
        has_error: false,
        error_type: "",
        error_verbose: "",
        url: "",
        loading: false,
        done: false,
      },
      payout_data: {
        end_date: "",
        start_date: "",
        donations: 0,
        shop: 0,
        donation_fees: 0,
        shop_fees: 0,
        vat: 0,
        aga: 0,
        tax: 0,
        salary: 0,
        phone_number: "",
        sid: null,
        ssn: "",
      },
      add_note:false,
      show_end_date: false,
      show_start_date: false,
      payout_dialog: false,
      hover_sid: null,
      old_streamers: [],
      selected_only: false,
      selected_row: [],
      edit_row: false,
      row_in_edit: {},
      search: "",
      streamers: [],
        nn_title:"Vi saknar dina uppgifter",
        nn_message:"Du behöver komplettera uppgifter för att en utbetalning skall äga rum",
        nn_links_to:"/payments",
        nn_action:"Uppdatera uppgifter",
      suggestions:{
        title:["Vi saknar dina uppgifter"],
        message:["Du behöver komplettera uppgifter för att en utbetalning skall äga rum"],
        links_to:["/payments"],
        action:["Uppdatera uppgifter"]
      },
      headers: [
        { text: "Namn", align: "start", sortable: true, value: "USER_NAME" },
        { text: "Notes", align: "start", sortable: true, value: "NOTES" },

        { text: "Sid", align: "start", sortable: true, value: "SID" },
        {
          text: "P.nr",
          align: "start",
          sortable: true,
          value: "PERSONAL_NUMBER",
        },
        { text: "Lön", align: "start", sortable: true, value: "SALARY" },
      ],
    };
  },
  methods: {
    create_payout: function() {
      this.reset_payout_status();

      let http = new XMLHttpRequest();
      http.withCredentials = true;

      let today_date = new Date().toLocaleDateString();

      let url = "/api/createSwishDeposit?";
      let profit =
        parseInt(this.payout_data.donation_fees) +
        parseInt(this.payout_data.shop_fees);
      let params =
        "RECIPIENT=" +
        this.payout_data.sid +
        "&DATE_REG=" +
        today_date +
        "&STATUS=" +
        "Betalad" +
        "&FROM_DATE=" +
        this.payout_data.start_date +
        "&TO_DATE=" +
        this.payout_data.end_date +
        "&COMMENT=" +
        "" +
        "&AMOUNT=" +
        this.payout_data.salary +
        "&TYPE=" +
        "V2" +
        "&DONATION_EARNED=" +
        this.payout_data.donations +
        "&HICARDS_EARNED=" +
        this.payout_data.shop +
        "&DONATION_FEE=" +
        this.payout_data.donation_fees +
        "&HICARDS_FEE=" +
        this.payout_data.shop_fees +
        "&HICARDS_VAT=" +
        this.payout_data.vat +
        "&DONATIONS_AGA=" +
        this.payout_data.aga +
        "&HICARDS_AGA=" +
        "0" +
        "&TAX=" +
        this.payout_data.tax +
        "&PROFIT=" +
        profit +
        "&RECIPIENT_NUMBER=" +
        this.payout_data.phone_number +
        "&SSN=" +
        this.payout_data.ssn;
      let self = this;
      http.open("POST", url, true);
      self.payout_status.loading = true;

      http.setRequestHeader(
        "Content-type",
        "application/x-www-form-urlencoded"
      );
      http.onreadystatechange = function() {
        //Call a function when the state changes.

        if (http.readyState === 4 && http.status === 401) {
          console.log("error");
        } else if (http.readyState === 4 && http.status === 200) {
          let resp_p = JSON.parse(http.responseText);
          if (resp_p.error) {
            self.payout_status.has_error = true;
            self.payout_status.error_type = resp_p.type;
            self.payout_status.loading = false;
            if ("error_verbose" in resp_p) {
              self.payout_status.error_verbose =
                resp_p.error_verbose[0].errorMessage;
            }
          } else {
            self.payout_status.url = resp_p.url;
            self.check_status(self.payout_status.url);
          }
        } else if (http.readyState === 4 && http.status !== 200) {
          console.log(
            "riperoni",
            "ett fel inträffade i DB, vafaaan Mika",
            "negative",
            3000
          );
        }
      };

      http.send(params);
    },

    check_status: function(url_id) {
      let http = new XMLHttpRequest();
      http.withCredentials = true;

      let url = "/api/get_payout_status?url=" + url_id;
      let self = this;
      http.open("GET", url, true);

      http.setRequestHeader(
        "Content-type",
        "application/x-www-form-urlencoded"
      );
      http.onreadystatechange = function() {
        //Call a function when the state changes.

        if (http.readyState === 4 && http.status === 401) {
          console.log("error");
        } else if (http.readyState === 4 && http.status === 200) {
          let resp = JSON.parse(http.response);
          let body_p = JSON.parse(resp.body);
          if (body_p.status === "PAID") {
            self.payout_status.loading = false;
            self.payout_status.done = true;
            self.payed_to[self.payout_data.sid] = true;
          } else if (body_p.status === "ERROR") {
            self.payout_status.loading = false;
            self.payout_status.done = false;
            self.payout_status.has_error = true;
            self.payout_status.error_type = "Swish payment ERROR (??)";
          } else {
            setTimeout(function() {
              self.check_status(url_id);
            }, 500);
          }
        } else if (http.readyState === 4 && http.status !== 200) {
          console.log("some error");
        }
      };

      http.send();
    },

    payout: function(streamer) {
      console.log(streamer);
      this.payout_data.donations = streamer.DONATION_EARNED;
      this.payout_data.shop = streamer.SHOP_EARNED;
      this.payout_data.donation_fees = streamer.DONATION_FEES;
      this.payout_data.shop_fees = streamer.SHOP_FEES;
      this.payout_data.vat = streamer.SHOP_VAT;
      this.payout_data.aga = streamer.DONATION_EMPLOYER_FEE;
      this.payout_data.tax = streamer.TOTAL_TAX;
      this.payout_data.salary =
        streamer.DONATION_EARNED -
        streamer.DONATION_FEES +
        streamer.SHOP_EARNED -
        streamer.SHOP_VAT -
        streamer.SHOP_FEES -
        streamer.DONATION_EMPLOYER_FEE -
        streamer.TOTAL_TAX;
      this.payout_data.sid = streamer.SID;

      this.payout_data.ssn = parseSwedishSSN(streamer.PERSONAL_NUMBER);
      let telefonnummer = streamer.PHONE_NUMBER;
      if (telefonnummer[0] === "0") {
        telefonnummer = "46" + telefonnummer.substring(1);
      } else if (telefonnummer[0] === "+") {
        telefonnummer = telefonnummer.substring(1);
      }
      this.payout_data.phone_number = telefonnummer;

      this.update_dates(streamer.SID);

      this.payout_dialog = true;
    },

    update_dates: function(streamer_id) {
      let http = new XMLHttpRequest();
      http.withCredentials = true;

      this.payout_data.start_date = "";
      this.payout_data.end_date = "";

      let self = this;
      let url = "/api/future_deposits_admin?sid=" + streamer_id;
      http.open("GET", url, true);

      http.setRequestHeader(
        "Content-type",
        "application/x-www-form-urlencoded"
      );
      http.onreadystatechange = function() {
        //Call a function when the state changes.

        if (http.readyState === 4 && http.status === 401) {
          console.log("error");
        } else if (http.readyState === 4 && http.status === 200) {
          let resp = JSON.parse(http.response);
          console.log(resp);
          self.payout_data.start_date = resp.START_DATE;
          self.payout_data.end_date = resp.END_DATE;
        }
      };

      http.send();
    },

    select_all: function() {
      if (this.selected_row.length === 0) {
        this.selected_row = [];
        for (let i = 0; i < this.streamers.length; i++) {
          if (
            this.streamers[i].PERSONAL_NUMBER?.length > 2 &&
            this.streamers[i].PHONE_NUMBER?.length > 2
          ) {
            this.selected_row.push(this.streamers[i]);
          }
        }
      } else {
        this.selected_row = [];
      }
    },

    add_to_selected_row: function() {
      this.selected_row.push(this.row_in_edit);
      this.edit_row = false;
      this.row_in_edit = null;
    },

    view_more: function(data) {
      this.row_in_edit = data;
      this.edit_row = true;
    },
    image_error(event) {
      event.target.src = "https://hihat.io/api/avatar/no_image";
    },

    get_streamer_data(sid) {
      let http = new XMLHttpRequest();
      http.withCredentials = true;
      /**/

      let url = `/api/admin-data-user?sid=${sid}`;
      http.open("GET", url, true);
      let self = this;
      http.setRequestHeader(
        "Content-type",
        "application/x-www-form-urlencoded"
      );
      http.onreadystatechange = function() {
        //Call a function when the state changes.

        if (http.readyState === 4 && http.status === 200) {
          let respObj = JSON.parse(http.response);
          for (let i = 0; i < self.streamers.length; i++) {
            self.streamers[i].LOADED = true;
          }

          self.streamer_data[respObj.SID] = respObj;
        }
      };
      http.send();
    },
    get_payout_data(sid) {
      let http = new XMLHttpRequest();
      http.withCredentials = true;
      /**/

      let url = `/api/future_deposits_admin?sid=${sid}`;
      http.open("GET", url, true);
      let self = this;
      http.setRequestHeader(
        "Content-type",
        "application/x-www-form-urlencoded"
      );
      http.onreadystatechange = function() {
        //Call a function when the state changes.

        if (http.readyState === 4 && http.status === 200) {
          let respObj = JSON.parse(http.response);

          //self.payout_data[sid]=respObj;
          self.$set(self.payout_data, sid, respObj);
          for (let i = 0; i < self.streamers.length; i++) {
            self.streamers[i].RENDER_INDEX += 1;
          }
        }
      };
      http.send();
    },

    delete_note: function(nid) {
      let http = new XMLHttpRequest();
      http.withCredentials = true;
      let url = "/api/delete_note";
      let params = "NID=" + nid;
      let self = this;
      http.open("POST", url, true);

      http.setRequestHeader(
        "Content-type",
        "application/x-www-form-urlencoded"
      );
      http.onreadystatechange = function() {
        if (http.readyState === 4) {
          self.row_in_edit.NOTES = self.row_in_edit.NOTES.filter(
            (note) => note.NID !== nid
          );
        }
      };
      http.send(params);
    },
    create_note: function() {
      let http = new XMLHttpRequest();
      http.withCredentials = true;
      let url = "/api/create_note";
      let self = this;
      http.open("POST", url, true);
      let params = "TITLE="+this.nn_title+"&MESSAGE="+this.nn_message+"&ACTION="+this.nn_action+"&LINKSTO="+this.nn_links_to+"&SID="+this.row_in_edit.SID

      http.setRequestHeader(
        "Content-type",
        "application/x-www-form-urlencoded"
      );
      http.onreadystatechange = function() {
        if (http.readyState === 4) {
          if(http.status===200){
            self.add_note = false
            self.row_in_edit.NOTES.push(JSON.parse(http.responseText))
            self.nn_title = self.suggestions.title[0]
            self.nn_message = self.suggestions.message[0]
            self.nn_action = self.suggestions.action[0]
            self.nn_links_to = self.suggestions.links_to[0]
            



          }else{
            self.$store.commit("update_snackbar","Gick ej spara Note");
          }
        }
      };
      http.send(params);
    },

    create_xml: function() {
      const date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      if (month < 10) {
        month = "0" + month.toString();
      }
      let blanketter = "";

      for (let i = 0; i < this.selected_row.length; i++) {
        let personnummer = parseSwedishSSN(
          this.selected_row[i].PERSONAL_NUMBER
        );

        this.selected_row[i].PERSONAL_NUMBER = personnummer;
        let brutto_salary =
          this.selected_row[i].DONATION_EARNED -
          this.selected_row[i].DONATION_FEES +
          this.selected_row[i].SHOP_EARNED -
          this.selected_row[i].SHOP_VAT -
          this.selected_row[i].SHOP_FEES -
          this.selected_row[i].DONATION_EMPLOYER_FEE;
        let tax = this.selected_row[i].TOTAL_TAX;
        let blankett = `<agd:Blankett>
                        <agd:Arendeinformation>
                           <agd:Arendeagare>165591252225</agd:Arendeagare>
                           <agd:Period>${year}${month}</agd:Period>
                        </agd:Arendeinformation>
                        <agd:Blankettinnehall>
                           <agd:IU>
                              <agd:ArbetsgivareIUGROUP>
                                 <agd:AgRegistreradId faltkod="201">165591252225</agd:AgRegistreradId>
                              </agd:ArbetsgivareIUGROUP>
                              <agd:BetalningsmottagareIUGROUP>
                                 <agd:BetalningsmottagareIDChoice>
                                    <agd:BetalningsmottagarId faltkod="215">${personnummer}</agd:BetalningsmottagarId>
                                 </agd:BetalningsmottagareIDChoice>
                              </agd:BetalningsmottagareIUGROUP>
                              <agd:AvdrPrelSkatt faltkod="001">${tax}</agd:AvdrPrelSkatt>
                              <agd:RedovisningsPeriod faltkod="006">${year}${month}</agd:RedovisningsPeriod>
                              <agd:KontantErsattningUlagAG faltkod="011">${brutto_salary}</agd:KontantErsattningUlagAG>
                              <agd:Specifikationsnummer faltkod="570">${i +
                                1}</agd:Specifikationsnummer>
                           </agd:IU>
                        </agd:Blankettinnehall>
                     </agd:Blankett>`;
        blanketter += blankett;
      }

      let base_skv = `<?xml version="1.0" encoding="UTF-8"?>
                  <Skatteverket xmlns="http://xmls.skatteverket.se/se/skatteverket/da/instans/schema/1.1" xmlns:agd="http://xmls.skatteverket.se/se/skatteverket/da/komponent/schema/1.1" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" omrade="Arbetsgivardeklaration" xsi:schemaLocation="http://xmls.skatteverket.se/se/skatteverket/da/instans/schema/1.1 http://xmls.skatteverket.se/se/skatteverket/da/arbetsgivardeklaration/arbetsgivardeklaration_1.1.xsd">
                     <agd:Avsandare>
                        <agd:Programnamn>HIHAT 2022.0</agd:Programnamn>
                        <agd:Organisationsnummer>165591252225</agd:Organisationsnummer>
                        <agd:TekniskKontaktperson>
                           <agd:Namn>Carl Kernell</agd:Namn>
                           <agd:Telefon>+46 70-612 72 52</agd:Telefon>
                           <agd:Epostadress>carl@hihat.io</agd:Epostadress>
                        </agd:TekniskKontaktperson>
                        <agd:Skapad>${date.toLocaleDateString(
                          "sv"
                        )}T${date.toLocaleTimeString()}</agd:Skapad>
                     </agd:Avsandare>
                     <agd:Blankettgemensamt>
                        <agd:Arbetsgivare>
                           <agd:AgRegistreradId>165591252225</agd:AgRegistreradId>
                           <agd:Kontaktperson>
                              <agd:Namn>Mika Köpberg</agd:Namn>
                              <agd:Telefon>+46 70-268 05 07</agd:Telefon>
                              <agd:Epostadress>mika@hihat.io</agd:Epostadress>
                           </agd:Kontaktperson>
                        </agd:Arbetsgivare>
                     </agd:Blankettgemensamt>
                  ${blanketter}
                  </Skatteverket>`;

      this.download(base_skv, `${year}${month}_skatteverket.xml`, "text/plain");
    },
    download(data, filename, type) {
      var file = new Blob([data], { type: type });
      if (window.navigator.msSaveOrOpenBlob)
        // IE10+
        window.navigator.msSaveOrOpenBlob(file, filename);
      else {
        // Others
        var a = document.createElement("a"),
          url = URL.createObjectURL(file);
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        setTimeout(function() {
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        }, 0);
      }
    },

    get_streamers: function() {
      let http = new XMLHttpRequest();
      http.withCredentials = true;
      /**/

      let url = "/api/future_deposits2";
      http.open("GET", url, true);
      let self = this;
      http.setRequestHeader(
        "Content-type",
        "application/x-www-form-urlencoded"
      );
      http.onreadystatechange = function() {
        //Call a function when the state changes.

        if (http.readyState === 4 && http.status === 200) {
          self.streamers = Object.values(JSON.parse(http.response));
          for (let i = 0; i < self.streamers.length; i++) {
            self.streamers[i].DONATION_EMPLOYER_FEE +=
              self.streamers[i].SHOP_EMPLOYER_FEE;
          }
        }
      };
      http.send();
    },

    reset_payout_status: function() {
      this.payout_status.has_error = false;
      this.payout_status.error_type = "";
      this.payout_status.url = "";
      this.payout_status.loading = false;
      this.payout_status.done = false;
      this.payout_status.error_verbose = "";
    },
  },
  computed: {},
  watch: {
    payout_dialog: function() {
      if (this.payout_dialog) {
        this.reset_payout_status();
      }
    },
    selected_only: function() {
      if (this.selected_only) {
        this.old_streamers = [];
        let marked_streamers = {};
        for (let i = 0; i < this.selected_row.length; i++) {
          marked_streamers[this.selected_row[i].SID] = true;
        }

        let old_streamers = this.streamers;
        for (let i = 0; i < old_streamers.length; i++) {
          if (!(old_streamers[i].SID in marked_streamers)) {
            this.old_streamers.push(old_streamers[i]);
          }
        }
        this.streamers = this.selected_row;
      } else {
        this.streamers = this.streamers.concat(this.old_streamers);
      }
    },
  },
  mounted: function() {
    let self = this;
    this.get_streamers();
    setTimeout(function() {
      if (!self.$store.state.STREAMER.IS_ADMIN) {
        self.$router.push(`/404`);
      }
    }, 1000);
  },
};

function parseSwedishSSN(ssn) {
  // Remove spaces and hyphens
  let cleanedSSN = ssn.replace(/[-\s]/g, "");

  // If already in the correct format, just return it
  if (cleanedSSN.length === 12) {
    return cleanedSSN;
  }

  // Extract the year, month, day, and the last four digits
  const yearMatch = cleanedSSN.substring(0, 2);
  const month = cleanedSSN.substring(2, 4);
  const day = cleanedSSN.substring(4, 6);
  const lastFourDigits = cleanedSSN.substring(6, 10);

  // Convert 2-digit year to 4 digits
  const currentYear = new Date().getFullYear();
  const currentCentury = Math.floor(currentYear / 100) * 100;
  const lastCentury = currentCentury - 100;

  let fullYear;
  if (parseInt(yearMatch, 10) <= currentYear % 100) {
    fullYear = currentCentury + parseInt(yearMatch, 10);
  } else {
    fullYear = lastCentury + parseInt(yearMatch, 10);
  }

  return `${fullYear}${month}${day}${lastFourDigits}`;
}
</script>

<style>
.v-tabs-bar {
  background: transparent !important;
}

.theme--dark.v-data-table tbody tr:hover {
  background: rgba(255, 255, 255, 0.1) !important;
}

.fillme {
  background: black;
}

.text-start {
  white-space: nowrap;
  font-size: 14px !important;
}

.v-data-table__wrapper {
  min-height: 400px;
}
</style>
